import { defineNuxtPlugin } from '#app'
import { vSwipe } from '~/directives/vSwipe'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('swipe', vSwipe)
})
